import script from "./ConfirmPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmPassword.vue?vue&type=style&index=0&id=1dc0097f&lang=css"

const __exports__ = script;

export default __exports__